import React, {useState} from 'react';
import {withdrawAccountMeasurement, withdrawMeasurementCapability} from '../api.measurement';
import {WITHDRAWAL_STORAGE_KEY} from '../measurement';
import {getToken} from '../auth';
import {useLang} from '../i18n/LanguageContext';
export default function MeasurementPrivacy() {
  const {lang} = useLang();
  const cs = lang === 'cs';
  const [key, setKey] = useState(() => {try {return localStorage.getItem(WITHDRAWAL_STORAGE_KEY) || '';} catch {return '';}});
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(false);
  const signedIn = Boolean(getToken());
  const withdraw = async (account: boolean) => {
    setBusy(true);setError(false);setDone(false);
    try {
      if (account) {
        // Account withdrawal does not revoke other accounts sharing this browser capability.
        await withdrawAccountMeasurement();
      } else {
        const submittedKey = key;
        await withdrawMeasurementCapability(submittedKey);
        let remainingKey = '';
        try {
          const storedKey = localStorage.getItem(WITHDRAWAL_STORAGE_KEY);
          if (storedKey === submittedKey) localStorage.removeItem(WITHDRAWAL_STORAGE_KEY);
          else remainingKey = storedKey || '';
        } catch { /* server withdrawal succeeded; do not claim local storage was cleared */ }
        setKey(remainingKey);
      }
      setDone(true);
    } catch {setError(true);} finally {setBusy(false);}
  };
  return <main style={{maxWidth: 640, margin: '32px auto', padding: 24}}>
    <h1>{cs ? 'Souhlas s reklamním měřením' : 'Advertising measurement consent'}</h1>
    <p>{cs ? 'Odvoláním se smažou uložené identifikátory kliknutí a zastaví další odesílání. Účet a ověření e-mailu zůstanou zachovány. Již odeslané události tím nelze odstranit z Google Ads.' : 'Withdrawal clears stored click identifiers and stops future uploads. Your account and email verification are preserved. This cannot remove events already sent to Google Ads.'}</p>
    <p>{cs ? 'Před přihlášením použijte klíč uložený v prohlížeči při registraci. Můžete si jej zkopírovat pro použití v jiném prohlížeči. Po přihlášení můžete souhlas odvolat bez klíče.' : 'Before login, use the removal key saved in this browser at signup. You can copy it for another browser. After login, you can withdraw for your account without the key.'}</p>
    <label htmlFor="withdrawal-key">{cs ? 'Klíč pro odvolání' : 'Removal key'}</label>
    <input id="withdrawal-key" value={key} maxLength={64} onChange={e => setKey(e.target.value)} style={{display: 'block', width: '100%', margin: '12px 0'}} autoComplete="off" />
    <button type="button" disabled={busy || !/^[a-f0-9]{64}$/.test(key)} onClick={() => withdraw(false)}>{cs ? 'Odvolat uložený souhlas' : 'Withdraw saved consent'}</button>
    {signedIn && <button type="button" disabled={busy} onClick={() => withdraw(true)} style={{marginLeft: 12}}>{cs ? 'Odvolat souhlas účtu' : 'Withdraw account consent'}</button>}
    {done && <p role="status">{cs ? 'Souhlas byl odvolán.' : 'Consent withdrawn.'}</p>}
    {error && <p role="alert">{cs ? 'Odvolání se nezdařilo. Zkuste to znovu.' : 'Withdrawal failed. Please try again.'}</p>}
  </main>;
}
